const Storage = {
    set: (key, data) => {
        window.localStorage.setItem(key, data);
    },
    has: (key) => {
        return window.localStorage.getItem(key) !== null;
    },
    get: (key) => {
        if (Storage.has(key)) {
            return window.localStorage.getItem(key);
        }
        return null;
    },
    remove: (key) => {
        window.localStorage.removeItem(key);
    }
};

export default Storage;


// WEBPACK FOOTER //
// ./src/services/Storage.js